import React from 'react';
import PropTypes from 'prop-types';
import TabContent from './TabContent';

const FinancingTabContent = (props) => {
    const { tab, active } = props;
    return <TabContent tab={tab} active={active} />;
};

FinancingTabContent.defaultProps = {};

FinancingTabContent.propTypes = {
    tab: PropTypes.object.isRequired,
    active: PropTypes.bool.isRequired,
};

export default FinancingTabContent;
